// import React from 'react';
// import ReactDOM from 'react-dom';
// import axios from 'axios';
// import { Provider } from 'react-redux';
// import { Provider as AlertProvider } from 'react-alert';
// import AlertTemplate from 'react-alert-template-basic';
// import App from './containers/App';
// import { API_BASE_URL } from './constants';
// import * as serviceWorkerRegistration from './serviceWorkerRegistration';
// import { PersistGate } from 'redux-persist/integration/react'
// import { store } from './store/store'
// // import { persistor } from './store/store'

// const alertOptions = {
//   position: 'bottom center',
//   timeout: 5000,
//   offset: '30px',
//   transition: 'fade',
//   zIndex: 1550
// };

// axios.defaults.baseURL = API_BASE_URL;

// ReactDOM.render(
//   <Provider store={store}>
//     {/* <PersistGate loading={null} persistor={persistor}> */}
//       <AlertProvider template={AlertTemplate} {...alertOptions}>
//         <App />
//       </AlertProvider>
//     {/* </PersistGate> */}

//   </Provider>, document.getElementById('root')
// );

// // If you want your app to work offline and load faster, you can change
// // unregister() to register() below. Note this comes with some pitfalls.
// // Learn more about service workers: https://cra.link/PWA

// serviceWorkerRegistration.register({
//   onUpdate: registration => {
//     alert('New version available!  Ready to update?');
//     if (registration && registration.waiting) {
//       registration.waiting.postMessage({ type: 'SKIP_WAITING' });
//     }
//     window.location.reload();
//   }
// });

import React from 'react';
import ReactDOM from 'react-dom';
import axios from 'axios';
import { Provider } from 'react-redux';
import { Provider as AlertProvider } from 'react-alert';
import AlertTemplate from 'react-alert-template-basic';
import App from './containers/App';
import { API_BASE_URL } from './constants';
import * as serviceWorkerRegistration from './serviceWorkerRegistration';
import { store, persistor } from './store/store'; // ✅ Import persistor
import { PersistGate } from 'redux-persist/integration/react'; // ✅ IMPORT THIS

const alertOptions = {
    position: 'bottom center',
    timeout: 5000,
    offset: '30px',
    transition: 'fade',
    zIndex: 1550
};

axios.defaults.baseURL = API_BASE_URL;

ReactDOM.render(
    <Provider store={store}>
        {/* ✅ UNCOMMENT PersistGate */}
        <PersistGate loading={null} persistor={persistor}>
            <AlertProvider template={AlertTemplate} {...alertOptions}>
                <App />
            </AlertProvider>
        </PersistGate>
    </Provider>,
    document.getElementById('root')
);

// ... rest of your service worker registration
serviceWorkerRegistration.register({
    onUpdate: registration => {
        alert('New version available! Ready to update?');
        if (registration && registration.waiting) {
            registration.waiting.postMessage({ type: 'SKIP_WAITING' });
        }
        window.location.reload();
    }
});

// // If you want to start measuring performance in your app, pass a function
// // to log results (for example: reportWebVitals(console.log))
// // or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
// // reportWebVitals(console.log);